import { Box, Text, Chip } from '@ltvco/refresh-lib/theme';
import { History, Clear } from '@mui/icons-material';
import { useEffect, useState } from 'react';

import {
  RecentSearchContainer,
  RecentSearchHeader,
  RecentSearchChipsWrapper,
  ClearAllChip,
  SearchResultChip,
} from './components';
import {
  getRecentSearches,
  addRecentSearch,
  clearRecentSearches,
  type RecentSearch,
} from './utils';

interface RecentSearchSuggestionsProps {
  currentSearchAddress?: string;
  // eslint-disable-next-line no-unused-vars
  onSuggestionClick: (address: string) => void;
}

const RecentSearchSuggestions = ({
  currentSearchAddress,
  onSuggestionClick,
}: RecentSearchSuggestionsProps) => {
  const [recentSearches, setRecentSearches] = useState<RecentSearch[]>(
    getRecentSearches()
  );

  // Add current search to recent searches when it changes
  useEffect(() => {
    if (currentSearchAddress && currentSearchAddress.trim()) {
      addRecentSearch(currentSearchAddress.trim());
      setRecentSearches(getRecentSearches());
    }
  }, [currentSearchAddress]);

  const handleClearAll = () => {
    clearRecentSearches();
    setRecentSearches([]);
  };

  if (recentSearches.length === 0) {
    return null;
  }

  return (
    <RecentSearchContainer>
      <RecentSearchHeader>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <History
            sx={{
              color: 'text.secondary',
              fontSize: '1rem',
            }}
          />
          <Text variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
            Recent Searches
          </Text>
        </Box>

        <ClearAllChip>
          <Chip
            label="Clear All"
            variant="outlined"
            size="small"
            onClick={handleClearAll}
            icon={<Clear sx={{ fontSize: '0.875rem' }} />}
          />
        </ClearAllChip>
      </RecentSearchHeader>

      <RecentSearchChipsWrapper>
        {recentSearches.map((search) => (
          <SearchResultChip key={`${search.address}-${search.timestamp}`}>
            <Chip
              label={search.address}
              variant="outlined"
              clickable
              onClick={() => onSuggestionClick(search.address)}
            />
          </SearchResultChip>
        ))}
      </RecentSearchChipsWrapper>
    </RecentSearchContainer>
  );
};

export default RecentSearchSuggestions;
